import React from "react";
import BaseComponent from '../BaseComponent';

import ImagePath from 'images/team4.jpg';

class JoinUs extends BaseComponent {
  render() {
    return (
      <div className="light-grey-background">
        <div className="container pt-5 pb-5">
          <div className="row justify-content-center">
            <div className="col-12 text-center pad-2">
              <div className="display-3 bold dark-green mt-5 mb-5" data-aos="fade-up">
                Join us to reinvent chronic disease monitoring.
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 pad-2">
              <img src={ImagePath} className='img-fluid w-100' data-aos="fade-up" style={{maxHeight: '500px', objectFit: 'cover'}} />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10 pad-2 mt-5">
              <p className='gw-paragraph gw-lighter mb-3 dark-green text-center' data-aos="fade-up">
                We're looking for energetic, creative, talented people who like
                challenges. If you're willing to get your hands dirty and to try
                and explore ideas before assuming they're impossible, you're our
                kinda recruit. Together, let's save lives from chronic disease.
              </p>
              <p className='gw-paragraph gw-lighter pb-5 dark-green text-center' data-aos="fade-up">
                Interested in applying for a position or enquire about current openings? Send us your resume at <a className="link" href="mailto:careers@graphwear.co">careers@graphwear.co</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default JoinUs
